import { ReactNode } from 'react';
import { Box, Dialog, Typography, useTheme } from '@mui/material';

import CommonButton from '../CommonButton';

interface CommonModalPropsType {
  handleClose: () => void;
  open: boolean;
  title: string;
  children: ReactNode;
  type: 'success' | 'error' | 'notice';
}

const CommonModal = ({ handleClose, open, title, children, type }: CommonModalPropsType) => {
  // theme
  const theme = useTheme();

  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          width: '420px',
          height: '320px',
          padding: '32px 24px 24px 24px',
          borderRadius: '20px',
        },
      }}
      open={open}
    >
      <Box
        sx={{
          height: '300px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          textAlign: 'center',
        }}
      >
        <Typography
          color={
            type === 'success'
              ? theme.background.blue
              : type === 'notice'
              ? theme.background.green
              : theme.background.red
          }
          variant="h3"
        >
          {title}
        </Typography>
        {children}

        <CommonButton
          sx={{
            width: '100%',
            borderRadius: '10px',
            padding: '10px 0px',
            height: '48px',
          }}
          text="OK"
          variant="h5"
          color="#ffffff"
          bgColor={theme.brand.primary}
          handleClick={handleClose}
        />
      </Box>
    </Dialog>
  );
};

export default CommonModal;
